module.exports = __webpack_public_path__ + "media/images/peb/8mm/peb_aplusplus-b4fa0ad64141249b24a04537116548a6.png";